import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=65b54abf&scoped=true&lang=pug&"
import script from "./UserForm.vue?vue&type=script&lang=ts&"
export * from "./UserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b54abf",
  null
  
)

export default component.exports